import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import { formatNullable } from "../../../../../../common/src/util/dataUtil";
import config from "../../../../../../server/src/config";

import * as AdminActions from "../../../../actions/admin";

export const defaultState = {
    Formand: '',
    Kasserer: '',
    Loeslader: '',
    Kontrolformand: '',
};

class ClubContacts extends React.Component {

    static propTypes = {
        editMode: PropTypes.bool,
        club: PropTypes.object,
    }

    static defaultProps = {
        editMode: false,
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.getStateFromStore(props));
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.editMode || ((nextProps.club === null && this.props.club !== null) || (nextProps.club !== null && (this.props.club === null || this.props.club.Foreningsnr !== nextProps.club.Foreningsnr)))) this.setState(this.getStateFromStore(nextProps));
    }

    getStateFromStore(props) {
        if (props.club === null)
            return defaultState;
        else {
            const club = props.club;
            const updateReq = club.UpdateRequests.find(req => req.type === 'club') || null;
            const updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
            return {
                Formand: isUndefined(updates.Formand) ? (club.Formand === null ? '' : club.Formand) : (updates.Formand === null ? '' : updates.Formand),
                Kasserer: isUndefined(updates.Kasserer) ? (club.Kasserer === null ? '' : club.Kasserer) : (updates.Kasserer === null ? '' : updates.Kasserer),
                Loeslader: isUndefined(updates.Loeslader) ? (club.Loeslader === null ? '' : club.Loeslader) : (updates.Loeslader === null ? '' : updates.Loeslader),
                Kontrolformand: isUndefined(updates.Kontrolformand) ? (club.Kontrolformand === null ? '' : club.Kontrolformand) : (updates.Kontrolformand === null ? '' : updates.Kontrolformand),
            }
        }
    }

    fields = [];
    render() {

        const getContactInfo = memberNo => {
            const member = this.props.admin.members.get(memberNo) || null;
            const city = member === null || member.Postnr === null ? null : this.props.admin.zipCodes.get(member.Postnr) || null;
            return [
                <td key="address" style={{width: "50%"}}>
                    <div className="address-container">
                        {[
                            member === null || (member.Fornavn === null && member.Efternavn === null) ? null : <div key="line1">{formatNullable(member.Fornavn, '') + (member.Fornavn === null || member.Efternavn === null ? '' : ' ') + formatNullable(member.Efternavn, '')}</div>,
                            member === null || member.Adr === null ? null : <div key="line3">{member.Adr + (member.Husnr === null && member.Husbogstav === null ? '' : ' ') + formatNullable(member.Husnr, '') + formatNullable(member.Husbogstav, '') + (member.Etage === null && member.Placering === null ? '' : ' ') + formatNullable(member.Etage, '') + formatNullable(member.Placering, '')}</div>,
                            member === null || member.C_O_adresse === null ? null : <div key="line2">{member.C_O_adresse}</div>,
                            member === null || member.Postboks === null ? null : <div key="line4">Postboks {member.Postboks}</div>,
                            member === null || member.Postnr === null ? null : <div key="line5">{member.Postnr + (city === null || city.By === null ? '' : ' ' + city.By)}</div>,
                        ]}
                    </div>
                </td>,
                <td key="contact" style={{width: "50%"}}>
                    <div className="address-container">
                        {[
                            member === null || member.Kontaktnavn === null ? null : <div key="line1">{member.Kontaktnavn}</div>,
                            member === null || member.Tlf === null ? null : <div key="line2">Tlf. <a href={'tel:' + member.Tlf} tabIndex={-1}>{member.Tlf}</a></div>,
                            member === null || member.Email === null ? null : <div key="line3">Email. <a href={'mailto:' + member.Email} tabIndex={-1}>{member.Email}</a></div>,
                        ]}
                    </div>
                </td>
            ];
        };

        const updateReq = this.props.club === null ? null : this.props.club.UpdateRequests.find(req => req.type === 'club') || null;
        const updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
        const editMode = this.props.editMode;
        const formand = getContactInfo(this.state.Formand);
        const kasserer = getContactInfo(this.state.Kasserer);
        const kontrolFormand = getContactInfo(this.state.Kontrolformand);
        const loeslader = getContactInfo(this.state.Loeslader);
        return <div className={"form-page club-contacts " + (editMode ? "editable" : "read-only")}>
            <table className="main-form-table">
                <tbody>
                    <tr className="address-row">
                        <td className={"label-cell" + (isUndefined(updates.Formand) ? "" : " updated")}><span className="label-text"><label htmlFor="Formand">Formand</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Formand) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-small-field" containerClassName="display-inline-block"
                                                         name="Formand" id="Formand" maxLength="6" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]} value={this.state.Formand}
                                                         autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                         onChange={this.onMemberNumberFieldChange}
                                                         ref={instance => { this.fields[0] = instance; }}
                            /> : <span className="value-text">{this.state.Formand}</span>}
                            {isUndefined(updates.Formand) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Formand) + ')'}</span>
                            ]}
                        </td>
                        <td>
                            <table>
                                <tbody>
                                    <tr>
                                        {formand}
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr className="address-row">
                        <td className={"label-cell" + (isUndefined(updates.Kasserer) ? "" : " updated")}><span className="label-text"><label htmlFor="Kasserer">Kasserer</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Kasserer) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-small-field" containerClassName="display-inline-block"
                                                          name="Kasserer" id="Kasserer" maxLength="6" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]} value={this.state.Kasserer}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onMemberNumberFieldChange}
                                                          ref={instance => { this.fields[1] = instance; }}
                            /> : <span className="value-text">{this.state.Kasserer}</span>}
                            {isUndefined(updates.Kasserer) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Kasserer) + ')'}</span>
                            ]}
                        </td>
                        <td>
                            <table>
                                <tbody>
                                <tr>
                                    {kasserer}
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr className="address-row">
                        <td className={"label-cell" + (isUndefined(updates.Kontrolformand) ? "" : " updated")}><span className="label-text"><label htmlFor="Kontrolformand">Edb-kontakt</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Kontrolformand) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-small-field" containerClassName="display-inline-block"
                                                          name="Kontrolformand" id="Kontrolformand" maxLength="6" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]} value={this.state.Kontrolformand}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onMemberNumberFieldChange}
                                                          ref={instance => { this.fields[0] = instance; }}
                            /> : <span className="value-text">{this.state.Kontrolformand}</span>}
                            {isUndefined(updates.Kontrolformand) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Kontrolformand) + ')'}</span>
                            ]}
                        </td>
                        <td>
                            <table>
                                <tbody>
                                <tr>
                                    {kontrolFormand}
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr className="address-row">
                        <td className={"label-cell" + (isUndefined(updates.Loeslader) ? "" : " updated")}><span className="label-text"><label htmlFor="Loeslader">Kontrolformand</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Loeslader) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-small-field" containerClassName="display-inline-block"
                                                          name="Loeslader" id="Loeslader" maxLength="6" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]} value={this.state.Loeslader}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onMemberNumberFieldChange}
                                                          ref={instance => { this.fields[3] = instance; }}
                            /> : <span className="value-text">{this.state.Loeslader}</span>}
                            {isUndefined(updates.Loeslader) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Loeslader) + ')'}</span>
                            ]}
                        </td>
                        <td>
                            <table>
                                <tbody>
                                <tr>
                                    {loeslader}
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    }

    onMemberNumberFieldChange = (e) => {
        if (e.target.value.length === 6) {
            const member = this.props.admin.members.get(e.target.value) || null;
            if (member === null) this.props.dispatch(AdminActions.getMember(e.target.value));
        }
        this.onStandardFieldChange(e);
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = (onSuccess = null) => {
        if (this.allInputValid()) {
            const entity = {
                Formand: this.state.Formand === '' ? null : this.state.Formand,
                Kasserer: this.state.Kasserer === '' ? null : this.state.Kasserer,
                Kontrolformand: this.state.Kontrolformand === '' ? null : this.state.Kontrolformand,
                Loeslader: this.state.Loeslader === '' ? null : this.state.Loeslader,
            };
            if (this.props.club === null) this.props.dispatch(AdminActions.createClub(entity, onSuccess));
            else this.props.dispatch(AdminActions.updateClub(this.props.club.Foreningsnr, entity, onSuccess));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const isUndefined = value => typeof(value) === "undefined";

const mapStateToProps = (state) => ({
    auth: {
        isMainAdmin: state.auth.isMainAdmin,
        isSectionAdmin: state.auth.isSectionAdmin,
        isClubAdmin: state.auth.isClubAdmin,
        clubNumber: state.auth.clubNumber,
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        members: state.admin.members,
        zipCodes: state.admin.zipCodes,
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(ClubContacts);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/club/subPages/ClubContacts.js